import { Schema as S } from "effect";

const PartnerSchema = S.Struct({
  dcCustomerNo: S.String,
  name: S.String,
});

const DataItemSchema = S.Struct({
  partner: PartnerSchema,
  title: S.String,
  userDescr: S.String,
  urgency: S.Number,
  severity: S.String,
  allDay: S.Boolean,
  wasInTreatment: S.Boolean,
  arrivalTime: S.String,
  isReadOnly: S.Boolean,
  _id: S.String,
  start: S.String,
  end: S.String,
  details: S.String,
  calendar: S.String,
  scheduletype: S.String,
  duration: S.Number,
  plannedDuration: S.Number,
  adhoc: S.Boolean,
  pushtime: S.String,
  eta: S.String,
  scheduled: S.Number,
  lastEditedDate: S.String,
  lastEditor: S.String,
  roomId: S.String,
  orderInRoom: S.Number,
});

// The SDK client unwraps the vendor `{ meta, data }` envelope and raises
// `meta.errors` as exceptions, so this schema describes the payload (`data`).
export const DeletePartnerScheduleResponseSchema = S.Array(DataItemSchema);

export type DeletePartnerScheduleResponse = S.Schema.Type<typeof DeletePartnerScheduleResponseSchema>;
